
import React from 'react';
import swal from "sweetalert";
import FusionCharts from 'fusioncharts/core';
import StackedColumn3D from 'fusioncharts/viz/stackedcolumn3d';
import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion'

FusionCharts.addDep(StackedColumn3D);
FusionCharts.addDep(FusionTheme);

class StatusWebService extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            days: {},
            config: {},
            ctx: {}
        };
    }

    componentWillMount()
    {
        let self = this;
    }

    componentDidMount()
    {
        let self = this;
        let month_url = "";

        switch (month) {
            case "enero": month_url = "01"; break;
            case "febrero": month_url = "02"; break;
            case "marzo": month_url = "03"; break;
            case "abril": month_url = "04"; break;
            case "mayo": month_url = "05"; break;
            case "junio": month_url = "06"; break;
            case "julio": month_url = "07"; break;
            case "agosto": month_url = "08"; break;
            case "septiembre": month_url = "09"; break;
            case "octubre": month_url = "10"; break;
            case "noviembre": month_url = "11"; break;
            case "diciembre": month_url = "12"; break;
        }

        if (year >= 2023) {
            axios.get('/api/reports/' + month_url + '/' + year + '/status')
                .then(response => {
                    let labels = response.data.labels;
                    let values = response.data.count;

                    let data = [];

                    for (let i = 0; i < labels.length; i++) {
                        let data_json =
                        {
                            "seriesname": labels[i],
                            "data": [
                            {
                                "value": values[i]
                            }
                        ]
                        };

                        data.push(data_json);
                    }

                    const dataSource = {
                        "chart": {
                            "theme": "fusion",
                            "yAxisName": "# Clientes",
                            "showValues": "1",
                            "showLegend": "1",
                            "showTooltip": "1",
                            "legendPosition": "right",
                            "borderThickness": "0",
                            "palettecolors":"BCFF3D,E8990C,FF0000,4E0CE8,0DE9FF,F26363",
                            "showPercentValues": "1",
                        },
                        "categories": [
                            {
                                "category": [
                                    {
                                        "label": ""
                                    }
                                ]
                            }
                        ],
                        "dataset": data
                    };

                    FusionCharts.ready(function() {
                        let myChart = new FusionCharts({
                            type: "stackedcolumn3d",
                            renderAt: "status_ws-chart",
                            width: "100%",
                            height: "85%",
                            dataFormat: "json",
                            dataSource
                        }).render();
                    });

                })
                .catch(error => {
                    swal({
                        title: "¡Oh no!",
                        text: "No se han obtenido resultados.",
                        icon: "warning",
                    });
                });
        }
    }

    render()
    {
        return (
            <div id='status_ws-chart'></div>
        );
    }
}

export default StatusWebService;


// WEBPACK FOOTER //
// ./resources/assets/react/dashboard/StatusWebService.jsx